import { Box, Skeleton } from "@mui/material"

const ProviderNoteItemSkeleton = () => {
  return (
    <Box
      sx={{
        bgcolor: 'white',
        padding: '8px 8px 16px 8px',
        display: 'flex',
        position: 'relative',
        borderBottom: '1px solid',
        borderColor: 'primary.lightGray'
      }}
    >
      <Skeleton variant="circular" width={36} height={36} />
      <Box
        sx={{
          ml: '8px',
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}
      >
        <Skeleton variant="text" width={'100%'} />
        <Skeleton variant="text" width={'100%'} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Skeleton variant="rounded" width={'100%'} height={40} />
        </Box>
      </Box>
    </Box>
  )
}

export default ProviderNoteItemSkeleton